export enum OrderStatusKeyEnum {
    REPORTED = 'REPORTED',
    PLANNED = 'PLANNED',
    IN_PROGRESS = 'IN_PROGRESS',
    COMPLETED = 'COMPLETED',
    INVOICED = 'INVOICED',
    CANCELED = 'CANCELED',
}
